import { forwardRef, useEffect } from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, styled } from '@mui/material'
import { Button, Link, Typography } from '@carto/meridian-ds/components'
import { CheckCircleOutlineOutlined } from '@mui/icons-material'
import { useAppDispatch } from 'app/state'
import { showOnboardingChecklistCompletionConfirmation } from '../state/onboardingChecklistSlice'
import useOnboardingChecklist from '../utils/useOnboardingChecklist'
import { createMetricRequest } from 'features/metrics/state/metricsSlice'
import { MetricEventType } from 'features/metrics/api/metrics'
import settings from 'settings'

const Root = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  maxWidth: theme.spacing(60)
}))

const IconWrapper = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  width: theme.spacing(10.25),
  height: theme.spacing(10.25),
  borderRadius: '50%',
  margin: theme.spacing(1, 0, 2),
  '& svg': {
    width: theme.spacing(6.625),
    height: 'auto'
  },
  '& path': {
    fill: theme.palette.secondary.main
  }
}))

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const OnboardingChecklistConfirmation = forwardRef((_props: any, forwardedRef: any) => {
  const dispatch = useAppDispatch()
  const { toggleOnboardingChecklist } = useOnboardingChecklist()
  const { documentationUrl } = settings

  const close = () => {
    dispatch(showOnboardingChecklistCompletionConfirmation(false))
    toggleOnboardingChecklist()
  }

  useEffect(() => {
    dispatch(createMetricRequest(MetricEventType.OnboardingCompleted))
  }, [dispatch])

  return (
    <div ref={forwardedRef}>
      <Root p={4} aria-label="onboarding-checklist-confirmation">
        <IconWrapper>
          <CheckCircleOutlineOutlined />
        </IconWrapper>
        <Typography variant="subtitle1" mb={2}>
          <FormattedMessage id="home.onboarding.checklist.confirmation.title" />
        </Typography>
        <Typography variant="body2">
          <FormattedMessage
            id="home.onboarding.checklist.confirmation.content"
            values={{
              br: () => <br />,
              a: (content) => (
                <Link href={documentationUrl} underline="hover" rel="noopener noreferrer" target="_blank">
                  {content}
                </Link>
              )
            }}
          />
        </Typography>
        <Button color="primary" onClick={close}>
          <FormattedMessage id="home.onboarding.checklist.confirmation.button" />
        </Button>
      </Root>
    </div>
  )
})

export default OnboardingChecklistConfirmation
